const isValidTelephone = (text) => {
  const phoneReg = /^[\d#+-]+$/;
  return phoneReg.test(text);
};

export default isValidTelephone;
